const initialState = {
  loading: false,
  sport: [],
  featuredCampaigns: [],
  pagination: {
    pageNumber: 1,
    pageSize: 9
  },
  filter: {
    name: ''
  },
  states: []
};

const sportListings = (state = initialState, action) => {
  switch (action.type) {
    case 'SET_SEARCH_FILTER_FOR_ORGANIZATION_LISTINGS':
    case 'FOLLOW_COMPANY_ORGANIZATION_REQUEST':
    case 'FOLLOW_COMPANY_ORGANIZATION_SUCCESS':
    case 'FOLLOW_COMPANY_ORGANIZATION_FAILED':
    case 'SET_PAGINATION_FOR_ORGANIZATION_LISTINGS':
    case 'GET_ORGANIZATION_LISTINGS_REQUEST':
    case 'GET_ORGANIZATION_LISTINGS_SUCCESS':
    case 'GET_ORGANIZATION_LISTINGS_FAILED':
    case 'GET_FEATURED_CAMPAIGNS_FOR_ORGANIZATION_LISTINGS_REQUEST':
    case 'GET_FEATURED_CAMPAIGNS_FOR_ORGANIZATION_LISTINGS_SUCCESS':
    case 'GET_FEATURED_CAMPAIGNS_FOR_ORGANIZATION_LISTINGS_FAILED':
    case 'GET_STATES_LISTINGS_REQUEST':
    case 'GET_STATES_LISTINGS_SUCCESS':
    case 'GET_STATES_LISTINGS_FAILED':
    case 'GET_PLEDGE_OF_THE_DAY_SUCCESS':
    case 'GET PLEDGE OF THE DAY':
    case 'GET_PLEDGE_OF_THE_DAY_FAILED': {
      return {
        ...state,
        ...action.payload
      }
    }
    default: {
      return state;
    }
  }
};

export default sportListings;
